/* Lucky Cosmos mobile layer for Round Top Finds 2.0.
   Phones: arrow rows with a counter under swipe rows, RTF Cards: Image opens
   on card 2, one-time swipe nudge, Video slideshow arrows and no autoplay.
   Desktop: Featured blog posts arrows lined up with the post title.
   Loaded once from layout/theme.liquid. */
(function () {
  'use strict';
  var PHONE = window.matchMedia('(max-width: 749px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  /* LC 2026-10-11 (Ash): the Multicolumn "Explore More" rows get the same arrow row, counter and nudge as the other swipe rows. */
  var ROWS = '.rtf-cards-image .rtf-cards__grid, .rtf-tab-blogs .grid--mobile-slider, .shopify-section[id*="section_blog_list"] .grid--mobile-slider, .grid.multicolumn.grid--mobile-slider';
  var L = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
  var R = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 6 15 12 9 18"/></svg>';
  var interacted = false;

  function cards(track) {
    return Array.prototype.filter.call(track.children, function (c) { return c.offsetWidth > 0; });
  }
  function nearest(track) {
    var items = cards(track), mid = track.scrollLeft + track.clientWidth / 2, best = 0, dist = Infinity;
    items.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < dist) { dist = d; best = i; } });
    return best;
  }
  function goTo(track, i) {
    var items = cards(track); if (!items.length) return;
    i = Math.max(0, Math.min(items.length - 1, i));
    var c = items[i];
    track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
  }
  function makeRow(onPrev, onNext) {
    var row = document.createElement('div');
    row.className = 'lc-arrows';
    row.innerHTML = '<button type="button" aria-label="Previous">' + L + '</button><span class="lc-count" aria-live="polite"></span><button type="button" aria-label="Next">' + R + '</button>';
    var b = row.querySelectorAll('button');
    b[0].addEventListener('click', function () { interacted = true; var t = row.previousElementSibling; if (t) t.dataset.lcTouched = '1'; onPrev(); });
    b[1].addEventListener('click', function () { interacted = true; var t = row.previousElementSibling; if (t) t.dataset.lcTouched = '1'; onNext(); });
    return row;
  }
  function setupRow(track) {
    if (track.dataset.lcRow) return;
    track.dataset.lcRow = '1';
    var row = makeRow(function () { goTo(track, nearest(track) - 1); }, function () { goTo(track, nearest(track) + 1); });
    track.insertAdjacentElement('afterend', row);
    var btn = row.querySelectorAll('button'), count = row.querySelector('.lc-count');
    function update() {
      var n = cards(track).length, i = nearest(track);
      row.style.display = n > 1 ? '' : 'none';
      count.textContent = (i + 1) + ' / ' + n;
      btn[0].disabled = i <= 0; btn[1].disabled = i >= n - 1;
    }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    track.lcUpdate = update;
    update();
  }
  function startOnCard2(track) {
    if (!PHONE.matches || track.dataset.lcStart) return;
    track.dataset.lcStart = '1';
    var items = cards(track); if (items.length < 3) return;
    var c = items[1];
    track.scrollLeft = c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2;
  }

  /* One-time nudge: each row slides about 70px and back once when it first comes into view.
     LC FIX 2026-10-10 evening: it used to be cancelled by the visitor's first touch ANYWHERE on the page, and scrolling
     down a phone is a touch, so it never played. Now only touching that row itself (or its arrows) cancels it. */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting || e.intersectionRatio < 0.6 || e.target.dataset.lcNudged) return;
      e.target.dataset.lcNudged = '1'; io.unobserve(e.target);
      setTimeout(function () { nudge(e.target); }, 450);
    });
  }, { threshold: [0.6] }) : null;
  function nudge(el) {
    if (el.dataset.lcTouched || REDUCED.matches || !PHONE.matches || el.scrollWidth <= el.clientWidth + 4) return;
    var start = el.scrollLeft, dist = Math.min(72, el.clientWidth * 0.18), snap = el.style.scrollSnapType, beh = el.style.scrollBehavior, t0 = null, dur = 1100;
    el.style.scrollSnapType = 'none'; el.style.scrollBehavior = 'auto';
    function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur), k = p < 0.45 ? ease(p / 0.45) : 1 - ease((p - 0.45) / 0.55);
      el.scrollLeft = start + dist * k;
      if (el.dataset.lcTouched) { el.style.scrollSnapType = snap; el.style.scrollBehavior = beh; return; }
      if (p < 1) requestAnimationFrame(step); else { el.scrollLeft = start; el.style.scrollSnapType = snap; el.style.scrollBehavior = beh; }
    }
    requestAnimationFrame(step);
  }
  function watchTouch(track) {
    if (track.dataset.lcWatch) return;
    track.dataset.lcWatch = '1';
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { track.dataset.lcTouched = '1'; }, { passive: true });
    });
  }
  /* Tab Blogs: a tab's row only has size once its tab is shown. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.rtf-tab-blogs .tab-link')) return;
    setTimeout(function () { document.querySelectorAll(ROWS).forEach(function (t) { if (t.lcUpdate) t.lcUpdate(); }); }, 80);
  });

  ['touchstart', 'wheel', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, function () { interacted = true; }, { once: true, passive: true });
  });

  /* Video slideshow on phones: arrows with a counter instead of dots, and no autoplay. */
  function setupSlideshow(section) {
    if (section.dataset.lcVs) return;
    var carousel = section.querySelector('.vs-carousel'), prev = section.querySelector('[data-vs-prev]'), next = section.querySelector('[data-vs-next]'), dots = section.querySelectorAll('[data-vs-dot]');
    if (!carousel || !prev || !next || dots.length < 2) return;
    section.dataset.lcVs = '1';
    var row = makeRow(function () { prev.click(); }, function () { next.click(); });
    carousel.insertAdjacentElement('afterend', row);
    var count = row.querySelector('.lc-count');
    /* LC 2026-10-11 (Ash): on phones the arrow row sits right under the showing slide's video instead of under the
       whole write-up, so people can change slides without scrolling past the text. */
    function place(i) {
      if (!PHONE.matches) { if (row.parentNode !== carousel.parentNode) carousel.insertAdjacentElement('afterend', row); return; }
      var slides = [].slice.call(section.querySelectorAll('.vs-slide'));
      var cands = slides.filter(function (sl) { return String(sl.getAttribute('data-slide-index')) === String(i); });
      if (!cands.length) cands = slides;
      var left = carousel.getBoundingClientRect().left, cur = cands[0];
      cands.forEach(function (sl) { if (Math.abs(sl.getBoundingClientRect().left - left) < Math.abs(cur.getBoundingClientRect().left - left)) cur = sl; });
      var v = cur && cur.querySelector('.vs-slide__video');
      if (v && v.nextElementSibling !== row) v.insertAdjacentElement('afterend', row);
    }
    var lastI = null;
    function update() {
      var i = 0; dots.forEach(function (d, k) { if (d.classList.contains('is-active')) i = k; });
      count.textContent = (i + 1) + ' / ' + dots.length;
      place(i);
      /* LC 2026-10-11 (Ash): moving to another slide closes any write-up opened with "Show more", so the section
         goes back to its normal height instead of leaving empty space under the next slide. */
      if (lastI !== null && i !== lastI) {
        section.querySelectorAll('.vs-body.lc-vs-open').forEach(function (b) {
          b.classList.remove('lc-vs-open');
          var btn = b.nextElementSibling;
          if (btn && btn.classList.contains('lc-vs-more')) { btn.textContent = 'Show more'; btn.setAttribute('aria-expanded', 'false'); }
        });
      }
      lastI = i;
    }
    PHONE.addEventListener && PHONE.addEventListener('change', update);
    dots.forEach(function (d) { new MutationObserver(update).observe(d, { attributes: true, attributeFilter: ['class'] }); });
    update();
    clampText(section);
    /* The section pauses its timer while "hovered", so on phones it stays hovered. */
    if (PHONE.matches) {
      carousel.dispatchEvent(new Event('mouseenter'));
      window.addEventListener('load', function () { carousel.dispatchEvent(new Event('mouseenter')); });
      carousel.addEventListener('mouseleave', function () { if (PHONE.matches) carousel.dispatchEvent(new Event('mouseenter')); });
    }
  }

  /* LC 2026-10-11 (Ash): on phones each slide's write-up shows 6 lines, then a "Show more" link opens the rest in place
     ("Show less" closes it). The link only appears when the text runs past 6 lines. Desktop shows the full text. */
  function clampText(section) {
    section.querySelectorAll('.vs-body').forEach(function (body) {
      if (body.dataset.lcClamp) return;
      body.dataset.lcClamp = '1';
      body.classList.add('lc-vs-clamp');
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'lc-vs-more'; btn.textContent = 'Show more';
      btn.setAttribute('aria-expanded', 'false');
      body.insertAdjacentElement('afterend', btn);
      btn.addEventListener('click', function () {
        var open = body.classList.toggle('lc-vs-open');
        btn.textContent = open ? 'Show less' : 'Show more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      function check() {
        if (body.classList.contains('lc-vs-open')) return;
        btn.hidden = !(PHONE.matches && body.scrollHeight > body.clientHeight + 2);
      }
      check();
      window.addEventListener('load', check);
      window.addEventListener('resize', check);
    });
  }

  /* Featured blog posts on desktop: arrows start at the left edge of the showing slide's title.
     Measured against the title's own slide, so it does not matter where the slider has moved to,
     and it follows the text column when a slide puts the photo on the left. */
  function alignOne(s) {
    if (PHONE.matches) return;
    var p = s.querySelector('.flickity-button.previous'), n = s.querySelector('.flickity-button.next');
    var slide = s.querySelector('.editorial__slide.is-selected') || s.querySelector('.editorial__slide');
    var title = slide && slide.querySelector('.editorial__title');
    if (!p || !n || !title || !p.offsetParent) return;
    var inSlide = title.getBoundingClientRect().left - slide.getBoundingClientRect().left;
    var left = inSlide + s.getBoundingClientRect().left - p.offsetParent.getBoundingClientRect().left;
    p.style.left = left + 'px'; p.style.right = 'auto';
    n.style.left = (left + 52) + 'px'; n.style.right = 'auto';
  }
  function watchFeatured(s) {
    if (s.dataset.lcAlign) return;
    s.dataset.lcAlign = '1';
    var raf = 0;
    var mo = new MutationObserver(function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { alignOne(s); }); });
    s.querySelectorAll('.editorial__slide').forEach(function (sl) { mo.observe(sl, { attributes: true, attributeFilter: ['class'] }); });
  }
  function alignFeatured(root) {
    (root || document).querySelectorAll('.featured-posts .editorial__slider').forEach(function (s) {
      watchFeatured(s);
      alignOne(s);
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll(ROWS).forEach(function (track) {
      if (track.matches('.rtf-cards__grid')) startOnCard2(track);
      setupRow(track);
      watchTouch(track);
      if (io) io.observe(track);
    });
    root.querySelectorAll('[data-section-type="video-slideshow"]').forEach(setupSlideshow);
    alignFeatured(root);
    setTimeout(function () { alignFeatured(root); }, 800);
  }

  /* Wait for DOMContentLoaded so the sections' own scripts have bound their listeners first. */
  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  window.addEventListener('load', function () { alignFeatured(); });
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { alignFeatured(); }, 150); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Header search dropdown: match names inside articles, not only their titles.
   The theme asks /search/suggest for titles only; this adds the body field to that one request. */
(function () {
  var nativeFetch = window.fetch;
  if (!nativeFetch) return;
  var FIELDS = 'resources[options][fields]=title,author,body,tag,product_type,variants.title,vendor&';
  window.fetch = function (input, init) {
    if (typeof input === 'string' && input.indexOf('/search/suggest') !== -1 && input.indexOf('section_id=predictive-search') !== -1 && input.indexOf('[options][fields]') === -1) {
      input = input.replace('section_id=predictive-search', FIELDS + 'section_id=predictive-search');
    }
    return nativeFetch.call(window, input, init);
  };
})();

/* Phone menu: a menu item with sub-links opens as an accordion under itself (Ash 9/24 launch night).
   Tapping the arrow shows or hides its links and the rest of the menu stays in view.
   Tapping the item's name goes to its page. Replaces Broadcast's slide-over submenu. */
(function () {
  'use strict';
  var SEL = '.drawer--header mobile-sliderule';
  function setup(root) {
    (root || document).querySelectorAll(SEL).forEach(function (m) {
      if (m.dataset.lcAcc) return;
      var btn = m.querySelector(':scope > button.sliderow'), panel = m.querySelector(':scope > .sliderule__panel');
      if (!btn || !panel) return;
      m.dataset.lcAcc = '1';
      m.classList.add('lc-acc');
      btn.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(SEL + '.lc-acc > button.sliderow');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var m = btn.parentElement;
    var link = m.querySelector('.sliderow--back a.sliderow__title');
    if (!e.target.closest('.sliderule__chevron') && e.detail !== 0 && link) { window.location.href = link.href; return; }
    var open = !m.classList.contains('lc-acc-open');
    m.classList.toggle('lc-acc-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
  else setup();
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();

/* Phone menu scrolling on iPhone (Ash 9/24 launch night: "it freezes up").
   Broadcast's scroll lock watches every finger movement on the page and cancels any that starts
   at the top or bottom edge of the menu. On an iPhone, once the first movement of a swipe is
   cancelled, the whole swipe is dead, so the menu looks frozen. This keeps the menu's own swipes
   away from that lock and keeps the menu one pixel off its edges when a touch starts, so iPhone
   never hands the swipe to the page behind it. */
(function () {
  'use strict';
  function bind(sc) {
    if (!sc || sc.dataset.lcScroll) return;
    sc.dataset.lcScroll = '1';
    sc.addEventListener('touchstart', function () {
      var max = sc.scrollHeight - sc.clientHeight;
      if (max <= 0) return;
      if (sc.scrollTop <= 0) sc.scrollTop = 1;
      else if (sc.scrollTop >= max) sc.scrollTop = max - 1;
    }, { passive: true });
    sc.addEventListener('touchmove', function (e) {
      if (sc.scrollHeight > sc.clientHeight) e.stopPropagation();
    }, { passive: true });
  }
  function setup(root) {
    (root || document).querySelectorAll('.drawer--header .drawer__content__scroll').forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
  else setup();
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();

/* Page titles: "Round Top" never splits across two lines (Ash 9/27). Works with the even-lines rule in
   lc-mobile.css, which on its own broke "A Day In Round / Top With..." on phones. */
(function () {
  'use strict';
  function glue(root) {
    /* LC 2026-10-11 (Ash): post and card titles too, so "Round Top" never splits and, with text-wrap: pretty in
       lc-mobile.css, a title never ends on one word alone ("...Leanne Ford + / Grace Mitchell"). */
    (root || document).querySelectorAll('.hero__title.heading-x-large, .article__title, .editorial__title').forEach(function (h) {
      var w = document.createTreeWalker(h, NodeFilter.SHOW_TEXT), n;
      var last = null;
      while ((n = w.nextNode())) {
        if (n.data.indexOf('Round Top') !== -1) n.data = n.data.replace(/Round Top/g, 'Round Top');
        if (/\S/.test(n.data)) last = n;
      }
      /* Post and card titles of 4+ words: the last two words stay together, so the last line is never one word
         (also covers phones whose browser has no text-wrap: pretty). */
      if (last && !h.matches('.hero__title') && h.textContent.trim().split(/\s+/).length >= 4) {
        var txt = last.data.replace(/\s+$/, ''), i = txt.lastIndexOf(' ');
        if (i > 0 && !/\u00a0\S+$/.test(txt)) last.data = txt.slice(0, i) + ' ' + txt.slice(i + 1) + last.data.slice(txt.length);
      }
    });
  }
  /* LC 2026-10-11 (Ash): after the glue, each post/card title of 4+ words tries four ways of breaking (fill the lines
     or even them out, last two words joined or not) and keeps the one with no word alone on a line; ties keep the
     first. Stops cases like "The Halles: / Antiques, Art, and / After / Hours Energy". */
  function lines(t) {
    var toks = [], tw = document.createTreeWalker(t, NodeFilter.SHOW_TEXT), n;
    while ((n = tw.nextNode())) {
      var re = /[^\s ]+/g, m;
      while ((m = re.exec(n.data))) {
        var r = document.createRange(); r.setStart(n, m.index); r.setEnd(n, m.index + m[0].length);
        var rc = r.getClientRects(); if (rc.length) toks.push(Math.round(rc[rc.length - 1].top));
      }
    }
    var map = {}; toks.forEach(function (top) { map[top] = (map[top] || 0) + 1; });
    var keys = Object.keys(map).map(Number).sort(function (a, b) { return a - b; });
    var score = 0;
    keys.forEach(function (k, i) { if (keys.length > 1 && map[k] === 1) score += (i === keys.length - 1) ? 10 : 3; });
    return score;
  }
  function lastText(t) { var tw = document.createTreeWalker(t, NodeFilter.SHOW_TEXT), n, last = null; while ((n = tw.nextNode())) { if (/\S/.test(n.data)) last = n; } return last; }
  function setPair(t, on) {
    var last = lastText(t); if (!last) return;
    var d = last.data, txt = d.replace(/\s+$/, ''), tail = d.slice(txt.length);
    if (on) {
      var i = txt.lastIndexOf(' ');
      if (i > 0 && !/ \S+$/.test(txt)) last.data = txt.slice(0, i) + ' ' + txt.slice(i + 1) + tail;
    } else if (/ \S+$/.test(txt) && !/Round Top$/.test(txt)) {
      var k = txt.lastIndexOf(' '); last.data = txt.slice(0, k) + ' ' + txt.slice(k + 1) + tail;
    }
  }
  function tidy(root) {
    (root || document).querySelectorAll('.article__title, .editorial__title').forEach(function (t) {
      if (!t.offsetWidth || t.textContent.trim().split(/\s+/).length < 4) return;
      var ways = [['pretty', true], ['pretty', false], ['balance', true], ['balance', false]], best = null;
      ways.forEach(function (w) {
        t.style.textWrap = w[0]; setPair(t, w[1]);
        var s = lines(t); if (!best || s < best.s) best = { s: s, w: w };
      });
      t.style.textWrap = best.w[0]; setPair(t, best.w[1]);
    });
  }
  window.__lcGlue = function (root) { glue(root); tidy(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { glue(); });
  else glue();
  document.addEventListener('shopify:section:load', function (e) { glue(e.target); });
})();

/* Same-height post cards (Ash 10/11): in RTF Cards: Image, Blog list, Blog Category Landing and The Edit, the title and
   excerpt share 5 lines (a 2-line title gets 3 lines of excerpt, a 3-line title gets 2) and Read More sits on the same
   line across a row. Wide green and blue cards are left as they are. Same rule as RTF Tab Blogs, which has its own copy. */
(function () {
  'use strict';
  var SETS = [
    ['.rtf-cards-image', '.rtf-cards__card'],
    ['section[id^="BlogList--"]', '.blog-listing > .grid-item'],
    ['.blog-cat', '.blog-listing > .grid-item'],
    ['.blog-section', '.blog-listing > .grid-item']
  ];
  var BUDGET = 5;
  function lh(e) { var c = getComputedStyle(e); return parseFloat(c.lineHeight) || parseFloat(c.fontSize) * 1.2; }
  function clear(x) { ['display', '-webkit-box-orient', 'overflow', '-webkit-line-clamp'].forEach(function (p) { x.style.removeProperty(p); }); }
  function run() {
    if (window.__lcGlue) window.__lcGlue();
    SETS.forEach(function (s) {
      document.querySelectorAll(s[0]).forEach(function (sec) {
        var cards = [].slice.call(sec.querySelectorAll(s[1])).filter(function (c) { return c.offsetWidth > 0; });
        if (!cards.length) return;
        var minW = Math.min.apply(null, cards.map(function (c) { return c.offsetWidth; }));
        cards.forEach(function (c) {
          var wide = c.offsetWidth > minW * 1.5 || c.classList.contains('lc-bl-wide') || c.classList.contains('blog-cat__wide');
          var t = c.querySelector('.article__title'), x = c.querySelector('.article__excerpt');
          c.classList.toggle('lc-eq', !wide);
          if (!x) return;
          clear(x);
          if (wide || !t || getComputedStyle(x).display === 'none') return;
          var tl = Math.max(1, Math.round(t.getBoundingClientRect().height / lh(t)));
          x.style.display = '-webkit-box'; x.style.webkitBoxOrient = 'vertical'; x.style.overflow = 'hidden';
          x.style.webkitLineClamp = String(Math.max(1, BUDGET - tl));
        });
      });
    });
  }
  var t;
  function soon(ms) { clearTimeout(t); t = setTimeout(run, ms || 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  window.addEventListener('load', function () { soon(50); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { soon(50); });
  window.addEventListener('resize', function () { soon(150); });
  document.addEventListener('lc:bl-refresh', function () { soon(60); });
  document.addEventListener('click', function () { soon(350); });
  document.addEventListener('shopify:section:load', function () { soon(150); });
})();
/* Trademark mark in headings (added 2026-10-11, updated 2026-10-11 option C). Remove this block and the .lc-tm rule in lc-mobile.css to undo. */
(function () {
  var SEL = 'h1, h2, h3, h4, h5, h6, summary, [class*="heading-"], .footer__block__title';
  function wrap(root) {
    var els = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.textContent.indexOf('\u2122') === -1) continue;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [];
      while (walker.nextNode()) {
        var t = walker.currentNode;
        if (t.nodeValue.indexOf('\u2122') > -1 && !(t.parentNode && t.parentNode.classList && t.parentNode.classList.contains('lc-tm'))) nodes.push(t);
      }
      for (var j = 0; j < nodes.length; j++) {
        var parts = nodes[j].nodeValue.split('\u2122'), run = document.createElement('span');
        run.className = 'lc-tm-run';
        for (var k = 0; k < parts.length; k++) {
          if (k > 0) { var s = document.createElement('span'); s.className = 'lc-tm'; s.textContent = '\u2122'; run.appendChild(s); }
          if (parts[k]) run.appendChild(document.createTextNode(parts[k]));
        }
        nodes[j].parentNode.replaceChild(run, nodes[j]);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { wrap(); }); else wrap();
  document.addEventListener('shopify:section:load', function (e) { wrap(e.target); });
})();